import { SnapshotIn, types as t } from 'mobx-state-tree';
import { ScriptCaption } from './script-caption.store';
import { Character } from './character.store';

export const ScriptCaptionWithCharacter = ScriptCaption.named('ScriptCaptionWithCharacter').props({
  character: t.maybeNull(
    t.reference(Character, {
      onInvalidated(event) {
        event.removeRef();
      },
    })
  ),
});

export interface ScriptCaptionWithCharacterSnapshotIn
  extends SnapshotIn<typeof ScriptCaptionWithCharacter> {}
